// extracted by mini-css-extract-plugin
export default {"faqList_multiColumn":"faq--faqList_multiColumn","faqAnswer":"faq--faqAnswer","faqQuestion":"faq--faqQuestion","faqList":"faq--faqList"};